import { useEffect, useState } from "react";
import { selectName } from "../../features/name/name";
import { useSelector } from "react-redux";
import { BsFillSendFill } from 'react-icons/bs'
import { FaTrash } from 'react-icons/fa'
import { BiSolidUserCircle } from 'react-icons/bi'
import { MdModeEdit } from 'react-icons/md'
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { selectWindowWidth } from "../../features/windowWidth/windowWidth";

const reply_url = process.env.REACT_APP_API_URL + '/comments/reply';
const spaceRegex = /^[\s\t\u200B-\u200D\u202F\u205F\u3000]*$/;

const ReplyItem = (props) => {
  const name = useSelector(selectName);
  const [editingReply, setEditingReply] = useState(false);
  const [editingReplyText, setEditingReplyText] = useState('');
  const [deleteModal, setDeleteModal] = useState(false);
  const windowWidth = useSelector(selectWindowWidth);

  const handleEditReply = async () => {
    if (spaceRegex.test(editingReplyText)) {
      alert('請輸入有意義的留言！');
      return;
    }
    await fetch(reply_url, {
      method: 'PATCH',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ id: props.ele.id, content: editingReplyText })
    })
    props.refetchReply();
    setEditingReply(false);
  }

  const handleDeleteReply = async (e) => {
    e.preventDefault();
    await fetch(reply_url, {
      method: 'PATCH',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ id: props.ele.id, content: '[這則留言已被刪除]' })
    })
    props.refetchReply();
    setDeleteModal(false);
  }

  const handleClickEdit = (e) => {
    e.preventDefault();
    setEditingReply(true);
    setEditingReplyText(props.ele.content);
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    handleEditReply();
  }

  return (
    <>
      <Modal show={deleteModal} onHide={() => setDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>確認刪除</Modal.Title>
        </Modal.Header>
        <Modal.Body>確認要刪除留言嗎？</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setDeleteModal(false)}>
            取消
          </Button>
          <Button variant="danger" onClick={handleDeleteReply}>
            確認
          </Button>
        </Modal.Footer>
      </Modal>
      <Row className='mt-3'>
        <Col xs='auto' style={{ color: 'gray' }} >
          <BiSolidUserCircle size={20} color='#4b3615' className='mb-1 me-1' />
          {props.ele.user_id === props.authorID ? '原 PO' : props.ele.name}
        </Col>
        {editingReply ?
          <Col xs={4} sm={7} md={8}>
            <Form onSubmit={handleSubmit}>
              <Form.Control
                value={editingReplyText}
                onChange={(e) => setEditingReplyText(e.target.value)}
                style={{ overflow: 'hidden', resize: 'none', boxShadow: 'none' }}
              />
              <input type='submit' style={{ display: 'none' }}/>
            </Form>
          </Col>
          :
          <Col xs={4} sm={7} md={8}>
            {props.ele.content === '[這則留言已被刪除]' ?
              <span style={{ fontStyle: 'italic', color: 'gray' }}>{props.ele.content}</span>
              :
              <span>{props.ele.content}</span>}
          </Col>
        }
        {(name === props.ele.name && props.ele.content !== '[這則留言已被刪除]') &&
          <Col xs='auto'>
            {editingReply ?
              <BsFillSendFill
                size={18}
                className={windowWidth >= 576 ? 'me-3 edit-icon' : 'me-1 edit-icon'}
                onClick={handleEditReply}
              />
              :
              <MdModeEdit
                size={22}
                className={windowWidth >= 576 ? 'me-3 edit-icon' : 'me-1 edit-icon'}
                onClick={handleClickEdit}
              />
            }
            <FaTrash size={18} className='delete-icon' onClick={() => setDeleteModal(true)} />
          </Col>
        }
      </Row>
    </>
  )
}


export default ReplyItem;